import React from 'react';

import { SVGComponentProps } from './svg.types';

const LinearScaleSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <rect y="1.32" width="14" height="2" fill={fill} />
        <rect y="5.32" width="14" height="2" fill={fill} />
        <svg y="9.32">
          <path
            d="M1.69544 0C2.06362 0.00160676 2.4214 0.12115 2.71523 0.340964C3.00915 0.560766 3.22328 0.868945 3.32567 1.21931H5.36977C5.50792 0.751332 5.84453 0.365808 6.29205 0.163023C6.73969 -0.0396409 7.25412 -0.0396409 7.70165 0.163023C8.14928 0.365794 8.48589 0.751305 8.62404 1.21931H10.6743C10.8251 0.695309 11.223 0.276248 11.7418 0.095346C12.2605 -0.0855753 12.8356 -0.00587912 13.2844 0.309045C13.7332 0.623968 14 1.13513 14 1.68003C14 2.22493 13.7332 2.7361 13.2844 3.05101C12.8356 3.36593 12.2605 3.44564 11.7418 3.26471C11.223 3.08379 10.8251 2.66475 10.6743 2.14074H8.63021C8.49206 2.60872 8.15545 2.99425 7.70793 3.19703C7.26029 3.3997 6.74586 3.3997 6.29833 3.19703C5.8507 2.99426 5.51409 2.60875 5.37595 2.14074H3.32567C3.2099 2.54341 2.94647 2.88862 2.58714 3.10887C2.22783 3.329 1.79846 3.40837 1.38315 3.33125C0.967836 3.25423 0.596633 3.02618 0.342071 2.69199C0.0876112 2.35788 -0.0318432 1.94153 0.00728607 1.52464C0.0463104 1.10775 0.241098 0.720411 0.55338 0.438377C0.865667 0.156343 1.27287 0 1.69544 0Z"
            fill={fill}
          />
        </svg>
      </svg>
    </span>
  );
};

export default LinearScaleSVG;
